var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 25,
    viewBox: "0 0 80 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V4.36369V8.62571V12.9911V24.252H4.79858V12.9911H8.95227V8.62571H4.79858V4.36369H8.95227V0H4.79858H0Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5124 0H39.7139V19.8883V24.252H44.5124H48.0382V19.8883H44.5124V0Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2986 0H49.5V24.252H54.2986V0Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9793 0H55.7471V24.252H66.761V0H61.9776H61.9793ZM60.5456 19.8883V4.36369H61.9793V19.8883H60.5456Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2136 0H10.415V24.252H15.2136V0Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3147 0H29.1387V24.252H29.3147H33.922H38.2517V19.8883H33.922V13.3571H38.2517V8.99175H33.922V4.36369H38.2517V0H33.922H29.3147Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2755 0H16.2803V4.40775H16.6611V24.252H21.4597L27.6767 23.5046V0H17.2755ZM22.8781 4.36369V19.7273L21.4445 19.7713V4.36369H22.8781Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2016 0V7.79195L73.3008 0H73.0215H72.5831H68.2246V24.252H73.0215V14.8213L75.2016 24.1791V24.252H80.0002V0H75.2016Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9bc7cc608aabf71539b89d674361cd98.svg";
export { ForwardRef as ReactComponent };